import { Capacitor } from "@capacitor/core";
import { trackEvent } from "./analytics.js";

/**
 * Open a news article without leaving the app: Chrome Custom Tabs on
 * Android, SFSafariViewController on iOS (via @capacitor/browser) — the
 * user's back gesture returns straight to the list. On the web a normal new
 * tab is already the right behavior, so the caller's <a target="_blank">
 * stays in charge there.
 *
 * Returns true when it handled the open (caller should preventDefault).
 */
export function openArticle(url: string, source?: string): boolean {
  trackEvent("news_open", { source: source ?? "", native: Capacitor.isNativePlatform() });
  if (!Capacitor.isNativePlatform()) return false;
  void import("@capacitor/browser")
    .then(({ Browser }) => Browser.open({ url, toolbarColor: "#121212", presentationStyle: "popover" }))
    .catch((err) => {
      // Android TV often has no browser for Custom Tabs to borrow.
      console.warn("[news] in-app browser unavailable, falling back", err);
      window.open(url, "_blank", "noopener");
    });
  return true;
}
